import { ModelMapper } from "@api/mappers/mappers.types";

import { applyHighlight } from "@utils/textUtils";

import {
    HIGHLIGHT_POSTFIX,
    HIGHLIGHT_PREFIX,
} from "../storeSearchInput.config";
import { SearchItem, SearchItemType } from "../storeSearchInput.types";

export const storeMapper: ModelMapper<
    woosmap.map.stores.StorePrediction,
    SearchItem
> = store => ({
    // storeid format is [locale]1234 bv: fr1234
    value: store.store_id.slice(2),
    label: store.name,
    highlightedLabel: applyHighlight(
        HIGHLIGHT_PREFIX,
        HIGHLIGHT_POSTFIX,
        store.name,
        store.matched_substrings,
    ),
    type: SearchItemType.Store,
});
